import {
  HeadingGroup,
  ModalLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { FaSort } from "react-icons/fa";
import OrderColumn from "../../Global/OrderColumn";
import useTransactionLists from "./useTransactionLists";
import EmptyData from "../../Global/EmptyData";
import CustomDateRangePicker from "../../Global/CustomDateRangePicker";
import SendExcelData from "../../Admin/OrderList/SendExcelData";

const TransactionLists = () => {
  const {
    date,
    isLoading,
    isFetching,
    transactionList,
    transactionsState,
    showEditModal,
    isDateRangeApplied,
    paginationOptions,
    isUserExcelLinkSend,
    handleEditColumnsClick,
    updatetransactionFields,
    sendUserExcelDownload,
    handleDateRangeChange,
    handleExcelDownload,
    handleDateChange,
    handlePagination,
    handleClearClick,
    handlePageSize,
    handleSearch,
    modalClose,
    handleSort,
    refetch,
    getRow,
  } = useTransactionLists();
  return (
    <>
      <HeadingGroup title="Transactions" className={`pro-mb-4`}>
        <button
          className={`pro-btn pro-btn-outline-primary pro-items-center pro-ms-3`}
          type="submit"
          onClick={handleExcelDownload}
        >
          <span className="material-symbols-outlined x4">download</span>
          <span>{`Export Data`}</span>
        </button>
      </HeadingGroup>
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters={
            transactionsState?.search !== "" || isDateRangeApplied
              ? true
              : false
          }
          handleClear={handleClearClick}
          searchInputProps={{ value: transactionsState?.search }}
          handleActionClick={handleEditColumnsClick}
          dropDownFilter={
            <>
              <div className="col-auto">
                <CustomDateRangePicker
                  defaultDateRange={date}
                  handleDateRangeChange={handleDateRangeChange}
                />
              </div>
            </>
          }
          onDateChange={handleDateChange}
          initialDateRange={date}
        />
        {transactionList?.data?.result?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={transactionList?.data?.result || []}
            uniqueID={"id"}
            fields={transactionList?.data?.fields || []}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            handleSort={handleSort}
            getRow={getRow}
            loading={isFetching}
            clear={transactionsState?.clearSelection}
            perpage={transactionsState?.currentPageSize}
            assignable={false}
            deletable={false}
            editable={false}
            showCheckBox={false}
          />
        )}

        {transactionList?.data?.result?.length > 0 && (
          <Pagination
            currentPage={transactionsState?.currentPage}
            totalPageCount={Math.ceil(
              transactionsState.totalOrderCount /
                transactionsState?.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === transactionsState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={transactionList?.data?.fields || []}
              moduleId={transactionList?.data?.module_id}
              updateData={updatetransactionFields}
            />
          </div>
        </ModalLayout>
        <ModalLayout
          show={transactionsState.excelSendModal}
          handleClose={handleExcelDownload}
          title={`Send Excel Download Link`}
          // backdrop="static"
        >
          <div className="pro-m-5">
            <SendExcelData
              isWalletTransaction
              handleCloseModal={modalClose}
              sendExcelData={sendUserExcelDownload}
              isExcelLinkSend={isUserExcelLinkSend}
            />
          </div>
        </ModalLayout>
      </div>
    </>
  );
};

export default TransactionLists;
